// import { InMemoryCache } from 'apollo-cache-inmemory';
import { IntrospectionFragmentMatcher, InMemoryCache } from 'apollo-cache-inmemory';
// import { ReduxCache } from 'apollo-cache-redux';
import store from './store';

const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData: {
    __schema: {
      types: [
        {
          kind: 'INTERFACE',
          name: 'Source',
          possibleTypes: [
            { name: 'BitbucketSource' },
            { name: 'HTTPSource' },
          ],
        },
      ],
    },
  },
});

const cache = new InMemoryCache({
  store,
  fragmentMatcher,
  dataIdFromObject: obj => {
    const { __typename: type } = obj;
    switch (type) {
      case 'Viewer':
      case 'CreateUserPayload':
      case 'UpdatePasswordPayload':
        return 'Viewer';
      default:
        return `${obj.__typename}:${obj._id}`;
    }
  },
});

export default cache;



// WEBPACK FOOTER //
// ./src/data/cache.js